export const KEYS = {
  ASYMMETRY_REPORT_MENU_ITEM: 'asymmetry-report-menu-item',
  ASYMMETRY_REPORT_SETTINGS_BUTTON: 'asymmetry-report-settings-button',
  ASYMMETRY_REPORT_CREATE_TEMPLATE_BUTTON:
    'asymmetry-report-create-template-button',
  ASYMMETRY_REPORT_MODE_SELECT: 'asymmetry-report-mode-select',
  ASYMMETRY_REPORT_TEMPLATE_SAVE_BUTTON:
    'asymmetry-report-template-save-button',
  ASYMMETRY_REPORT_SETTINGS_SAVE_BUTTON:
    'asymmetry-report-settings-save-button',
  ASYMMETRY_MODE_SELECT: 'asymmetry-mode-select',
  ASYMMETRY_LEFT_TAG_SELECT: 'asymmetry-left-tag-select',
  ASYMMETRY_RIGHT_TAG_SELECT: 'asymmetry-right-tag-select',
  ASYMMETRY_REPORT_TIMEFRAME_SELECT: 'asymmetry-report-timeframe-select',
  ASYMMETRY_REPORT_TEMPLATE_LIST: 'asymmetryReport-list',
  ASYMMETRY_REPORT_TEMPLATE_SEARCH: 'asymmetryReport-template-search',

  /// METRIC SELECTOR
  METRIC_SELECTOR: 'metric-selector',
  METRIC_SELECTOR_TEST_TYPE_SELECT: 'metric-selector-test-type-select',
  METRIC_SELECTOR_TAGS_SELECT: 'metric-selector-tags-select',
  METRIC_SELECTOR_METRIC_SELECT: 'metric-selector-metric-select',
  METRIC_SELECTOR_ADD_METRIC_BUTTON: 'metric-selector-add-metric-button',

  /// ENTITY VIEW
  ENTITY_VIEW_ANALYZE: 'entity-view-analyze',
  ENTITY_VIEW_EXPORT: 'entity-view-export',

  /// DEVICE UPDATER
  DEVICE_UPDATER_MENU_ITEM: 'device-updater-menu-item',
  /// DEVICE UPDATER WIZARD
  WIZARD_STEPPER: 'wizard-stepper',
  WIZARD_STEPPER_STEP: 'wizard-stepper-step',

  // EID Entry Step
  WIZARD_EID_STEP: 'wizard-eid-step',
  WIZARD_EID_INPUT: 'wizard-eid-input',
  WIZARD_EID_VALID: 'wizard-eid-valid',
  WIZARD_EID_HEADING: 'wizard-eid-heading',

  // EID Confirmation Popup
  WIZARD_EID_CONFIRM_POPUP: 'wizard-eid-confirm-popup',
  WIZARD_EID_CONFIRM_BUTTON: 'wizard-eid-confirm-button',
  WIZARD_EID_CANCEL_BUTTON: 'wizard-eid-cancel-button',

  // Device Connection Step
  WIZARD_DEVICE_STEP: 'wizard-device-step',
  WIZARD_DEVICE_HEADING: 'wizard-device-heading',
  WIZARD_CONNECT_BUTTON: 'wizard-connect-button',
  WIZARD_DEVICE_CONNECTED: 'wizard-device-connected',

  // Unsupported Browser Screen
  WIZARD_UNSUPPORTED_SCREEN: 'wizard-unsupported-screen',
  WIZARD_UNSUPPORTED_TITLE: 'wizard-unsupported-title',
  WIZARD_UNSUPPORTED_CLOSE: 'wizard-unsupported-close',
  WIZARD_BROWSER_CHROME: 'wizard-browser-chrome',
  WIZARD_BROWSER_EDGE: 'wizard-browser-edge',

  // Wizard Navigation
  WIZARD_CONTINUE_BUTTON: 'wizard-continue-button',
  WIZARD_BACK_BUTTON: 'wizard-back-button',
  WIZARD_START_OVER_BUTTON: 'wizard-start-over-button',
  WIZARD_CLOSE_BUTTON: 'wizard-close-button',

  // Error Panel
  WIZARD_ERROR_PANEL: 'wizard-error-panel',
  WIZARD_ERROR_CODE: 'wizard-error-code',
};
